const USE_DESK_WIDGET_ID = '156026_40948'
const USE_DESK_SCRIPT_URL = `https://lib.usedesk.ru/secure.usedesk.ru/widget_${USE_DESK_WIDGET_ID}.js`
export const SUPPORT_SCRIPT_URL = USE_DESK_SCRIPT_URL
